import produce from 'immer';
import { getMappedURI } from './getMappedURI';
export const getMappedContentPaths = (content) => {
    return produce(content, (draft) => {
        if (draft?.asset?.src) {
            draft.asset.src = getMappedURI(draft.asset.src);
        }
        if (draft?.cover?.src) {
            draft.cover.src = getMappedURI(draft.cover.src);
        }
    });
};
//# sourceMappingURL=getMappedContentPaths.js.map